import { Reveal, SectionTag, SectionTitle } from "./shared";
import { PROFILES } from "../data/site";
import { ArrowUpRight } from "lucide-react";

export function Profiles({ onAdvisor }) {
  return (
    <section className="relative py-28 lg:py-40 bg-[#0A0A0A]" data-testid="profiles-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag>Where the Opportunity May Be</SectionTag>
        <div className="grid lg:grid-cols-2 gap-8 items-end mb-14">
          <SectionTitle>Different Goals. <span className="text-gold-gradient italic">Different Properties.</span></SectionTitle>
          <Reveal delay={0.15}>
            <p className="text-sm text-[#A1A1AA] leading-relaxed max-w-md lg:ml-auto">
              There is no single &ldquo;best&rdquo; property in GYC - only the property that fits your
              goal. Identify your profile, then we match the inventory.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4" data-testid="profiles-grid">
          {PROFILES.map((p, i) => (
            <Reveal key={p.num} delay={i * 0.08}>
              <button
                data-testid={`profile-card-${p.num}`}
                onClick={onAdvisor}
                className="group w-full text-left p-6 border border-[#D4AF37]/14 bg-[#111111] rounded-[2px] h-full flex flex-col hover:border-[#D4AF37]/55 hover:bg-[#D4AF37]/[0.04] transition-all duration-500"
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-serif-lux text-3xl text-[#D4AF37]/30 group-hover:text-[#D4AF37] transition-colors">{p.num}</span>
                  <ArrowUpRight size={16} className="text-[#3f3f46] group-hover:text-[#D4AF37] transition-colors" />
                </div>
                <h3 className="font-serif-lux text-xl text-[#F5F5F0] mb-3">{p.name}</h3>
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {p.assets.map((a) => (
                    <span key={a} className="text-[9px] uppercase tracking-[0.15em] px-2 py-1 border border-[#D4AF37]/20 text-[#F3E5AB]/70 rounded-full">{a}</span>
                  ))}
                </div>
                <p className="text-[12px] text-[#71717A] leading-relaxed mt-auto">{p.focus}</p>
              </button>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-[11px] text-[#71717A] leading-relaxed max-w-3xl border-l-2 border-[#D4AF37]/40 pl-4" data-testid="profiles-disclaimer">
            Property outcomes depend on market conditions, development progress, purchase price,
            holding period and other factors. No return is guaranteed.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
